import { TextField, Typography } from "@mui/material";
import {
  formatCraneMagnitude,
  normalizeCraneMagnitudeInput,
} from "../utils/formatCraneMagnitude";

interface WeightInputForOperationProps {
  value: string;
  onChange: (weight: string) => void;
  disabled: boolean;
  bgColor: string;
  borderColor: string;
  label?: string;
  placeholder?: string;
}

export const WeightInputForOperation = ({
  value,
  onChange,
  disabled,
  bgColor,
  borderColor,
  label = "Weight",
  placeholder = "0",
}: WeightInputForOperationProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(normalizeCraneMagnitudeInput(e.target.value));
  };

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    e.target.select();
  };

  return (
    <>
      {label ? (
        <Typography
          sx={{
            color: "text.secondary",
            fontSize: "1.2rem",
            fontStyle: "italic",
            fontWeight: 600,
            mb: 1.5,
          }}
        >
          {label}
        </Typography>
      ) : null}
      <TextField
        variant="outlined"
        value={formatCraneMagnitude(value, "")}
        onChange={handleChange}
        onFocus={handleFocus}
        size="medium"
        fullWidth
        disabled={disabled}
        type="text"
        placeholder={placeholder}
        slotProps={{
          input: {
            inputProps: {
              inputMode: "numeric",
              pattern: "[0-9,]*",
              style: {
                textAlign: "center",
                fontSize: "2rem",
                fontWeight: 600,
              },
            },
            sx: {
              bgcolor: disabled ? bgColor : "white",
              borderColor: borderColor,
              minHeight: "70px",
              fontSize: "2rem",
              padding: "16px",
              textAlign: "center",
              fontWeight: 600,
              borderRadius: "12px",
              height: "70px",
              "& .MuiOutlinedInput-notchedOutline": {
                borderWidth: "2px",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderWidth: "3px",
              },
            },
          },
        }}
      />
    </>
  );
};
